import {
  CHANNEL_NAME, FLIGHT_KEY, HOTEL_KEY,
  RECENT_SEARCH_EVENT_TYPE,
} from '../constants/categoryConstants';

export const transformRecentSearchFeedbackDataAll = (recentSearchData, lob) => {
  const lobDetails = [];
  let recentSearchIndex = 1;
  lobDetails.push({
    code: 'Category',
    value: recentSearchData[0]?.category,
  });
  if (lob === FLIGHT_KEY) {
    lobDetails.push({
      code: 'JourneyType',
      value: recentSearchData[0]?.journeyType,
    });
  }
  recentSearchData.forEach((recentSearch) => {
    if (lob === FLIGHT_KEY) {
      lobDetails.push({
        code: `SearchStartTerm${recentSearchIndex}`,
        value: recentSearch?.label,
      });
      lobDetails.push({
        code: `SearchDestinationTerm${recentSearchIndex}`,
        value: recentSearch?.toLabel,
      });
      lobDetails.push({
        code: `SearchStartDate${recentSearchIndex}`,
        value: recentSearch?.dates?.startDate,
      });
      if (recentSearch?.journeyType === 'RT') {
        lobDetails.push({
          code: `SearchEndDate${recentSearchIndex}`,
          value: recentSearch?.dates?.endDate,
        });
      }
    } else if (lob === HOTEL_KEY) {
      lobDetails.push({
        code: `StartDate${recentSearchIndex}`,
        value: recentSearch?.dates?.startDate,
      });
      lobDetails.push({
        code: `EndDate${recentSearchIndex}`,
        value: recentSearch?.dates?.endDate,
      });
      lobDetails.push({
        code: `DestinationSearchTerm${recentSearchIndex}`,
        value: recentSearch?.label,
      });
    }
    recentSearchIndex += 1;
  });

  return lobDetails;
};

export const transformRecentSearchFeedbackData = (recentSearchData, lob, suggestionIndex) => {
  const recentSearchSuggestion = recentSearchData[suggestionIndex - 1];
  if (lob === FLIGHT_KEY) {
    const lobDetails = [
      {
        code: 'Category',
        value: recentSearchSuggestion?.category,
      },
      {
        code: 'SearchStartTerm',
        value: recentSearchSuggestion?.label,
      },
      {
        code: 'SearchDestinationTerm',
        value: recentSearchSuggestion?.toLabel,
      },
      {
        code: 'SearchStartDate',
        value: recentSearchSuggestion?.dates?.startDate,
      },
      {
        code: 'JourneyType',
        value: recentSearchSuggestion?.journeyType,
      },
    ];
    if (recentSearchSuggestion?.journeyType === 'RT') {
      return [
        ...lobDetails,
        {
          code: 'SearchEndDate',
          value: recentSearchSuggestion?.dates?.endDate,
        },
      ];
    }
    return lobDetails;
  } if (lob === HOTEL_KEY) {
    return [
      {
        code: 'Category',
        value: recentSearchSuggestion?.category,
      },
      {
        code: 'StartDate',
        value: recentSearchSuggestion?.dates?.startDate,
      },
      {
        code: 'EndDate',
        value: recentSearchSuggestion?.dates?.endDate,
      },
      {
        code: 'DestinationSearchTerm',
        value: recentSearchSuggestion?.label,
      },
    ];
  }
  return [];
};

export const getPayloadForContextFeedbackLoop = ({
  recentSearchData,
  eventType,
  intentCode,
  lob,
  suggestionIndex,
  trackingId,
}) => {
  const recentSearchFeedbackData = suggestionIndex
    ? transformRecentSearchFeedbackData(recentSearchData, lob, suggestionIndex)
    : transformRecentSearchFeedbackDataAll(recentSearchData, lob);
  return {
    eventPayload: {
      channelName: CHANNEL_NAME,
      intentCode,
      intentDescription: `${lob} Recent Search Feedback from TLSOnline`,
      details: [
        {
          code: 'ContextDisposition',
          value: eventType === 'click' ? 'Clicked' : 'Presented',
        },
        {
          code: eventType === 'click' ? 'ClickedTime' : 'PresentedTime',
          value: new Date().toISOString(),
        },
        {
          code: 'TrackingId',
          value: trackingId,
        },
        ...recentSearchFeedbackData,
      ],
    },
    eventSource: CHANNEL_NAME,
    eventTransferDate: new Date().toISOString(),
    eventType: RECENT_SEARCH_EVENT_TYPE,
  };
};
